import React, { type ReactNode } from "react";
import type { SpaceProps } from "styled-system";
import * as Styles from "./styles/SidebarWrapperStyles";

type SidebarWrapperPropsType = {
    children: ReactNode;
    ignoreNavOffset?: boolean;
    top?: number;
    zIndex?: number;
    // Used on retailerscreens because it is not possible to see all collapsed filters on the big screen at once
    disableSticky?: boolean;
};

const SidebarWrapper = (props: SidebarWrapperPropsType & SpaceProps): JSX.Element => {
    const { children, top = 0, ignoreNavOffset, disableSticky } = props;
    return (
        <Styles.Wrapper
            id="or-sidebar-wrapper"
            {...props}
            ignoreNavOffset={ignoreNavOffset}
            top={top}
            disableSticky={disableSticky}
        >
            {children}
        </Styles.Wrapper>
    );
};

export default SidebarWrapper;
